import { timeToTimecodeWithFrames } from "../../utils";
import {getAssetColorsByType} from "../../../../../utils/colors"
class BaseTrack
{
    constructor (type, datas, file1, file2, channel, id, parent=null)
    {

        this.type = type;
        this.datas = datas;
        this.id = id;
        this.idfile1 = 0; // = id quand download ok
        this.idfile2 = 0; // idem

        this.parent = parent;

        this.file1 = file1;
        this.file2 = file2;
        this.channel = channel;


        this.defaultHeight = 50;
        this.minHeight = 50;
        this.maxHeight = 50;

        this.minimisable = false;
        this.minimised = false;
        this.minimisedHeight = this.defaultHeight;

        this.baseline = -1; // position en pixel d'afficgae
        this.height = this.defaultHeight; // hauteur en cours

        

        this.backcolor = "#202020";

        this.ontopmost = false;
        this.ontop = false;
        this.onbottom = false;
        this.onbottommost = false;


        this.drawObjects = [];

        this.toptrack = false;
        this.bottomtrack = false;
        this.nobuttons = false;

        this.width = 0;

        this.selectedbutton="";

        this.datasMove = null;

        this.posxboutons = {};


        this.startDrawTime = -1;
        this.endDrawTime = -1;
      
    }

    setNewId(id)
    {
        this.id = id;
        
    }

    setNewDatas(datas, id)
    {
        this.datas = datas;
        this.id = id;
    }

    getChannel()
    {
        return this.channel;
    }

    assombrirCouleur(hex, facteur = 0.5) {
        // Retirer le # si présent
        hex = hex.replace(/^#/, '');
      
        // Convertir les composantes R, G, B
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);
      
        // Appliquer le facteur de réduction
        r = Math.floor(r * facteur);
        g = Math.floor(g * facteur);
        b = Math.floor(b * facteur);
      
        // S'assurer que ça reste dans [0, 255]
        r = Math.max(0, Math.min(255, r));
        g = Math.max(0, Math.min(255, g));
        b = Math.max(0, Math.min(255, b));
      
        // Convertir à nouveau en hexadécimal
        const toHex = c => c.toString(16).padStart(2, '0');
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
      }
    


    drawTitle(context, img, stimecode, width, imgpoub, imgtoup, imgtodown, imgminimiser, imgagrandir)
    {
        
        if (this.baseline == -1) return;
        this.width = width;

        context.fillStyle = "#202020";
        context.clearRect(0,this.baseline,width,this.height );

        context.textBaseline = "middle";
        context.font = "12px courier new";
        

        
        var wt = context.measureText(this.id).width;

        const colors = getAssetColorsByType(this.type)

        context.fillStyle = colors.backcolor
        context.fillRect(28,this.baseline + this.height/2 - 8, wt + 2, 16)
        
        context.fillStyle=colors.color;

        context.fillText(this.id,30,this.baseline + this.height/2); 
        
        var styleimage = localStorage.getItem("default-icon-filter");
        

        context.filter  = styleimage;


        var maxHeight = this.height -2 ; if (maxHeight > 18 ) maxHeight = 18;
        var posy = this.height/2 - maxHeight/2;

        context.drawImage(img, 5, this.baseline + posy ,maxHeight,maxHeight);

        this.posxboutons = {};
        if (!this.nobuttons)
        {

            var startx = 20;
            context.filter = styleimage;


            if (this.minimisable)
            {
                if (this.selectedbutton == "minagr")
                {
                    context.shadowColor = "rgba(255,255,255, 0.7)";
                    context.shadowBlur = 5;
                    context.shadowOffsetX = 0;
                    context.shadowOffsetY = 0;            
                }
                else
                    context.shadowColor="transparent";

                if (this.minimised)
                    context.drawImage(imgagrandir, width - startx,this.baseline+ this.height/2 -8,16,16);
                else
                    context.drawImage(imgminimiser, width - startx,this.baseline+ this.height/2 -8,16,16);

                
                startx +=20;

            }


            if (this.selectedbutton == "poub")
            {
                context.shadowColor = "rgba(255,255,255, 0.7)";
                context.shadowBlur = 5;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;            
            }
            else
                context.shadowColor="transparent";


            
            context.drawImage(imgpoub, width - startx,this.baseline+ this.height/2 -8,16,16);
            startx +=20;
            
            if (!this.toptrack) 
            {
                if (this.selectedbutton == "toup")
                {
                    context.shadowColor = "rgba(255,255,255, 0.7)";
                    context.shadowBlur = 5;
                    context.shadowOffsetX = 0;
                    context.shadowOffsetY = 0;            
                    }
                else
                    context.shadowColor="transparent";
                context.drawImage(imgtoup, width - startx,this.baseline+ this.height/2 -8,16,16);
                
        
            }
            startx+=20;

            if (!this.bottomtrack) 
            {
                if (this.selectedbutton == "todown")
                {
                    context.shadowColor = "rgba(255,255,255, 0.7)";
                    context.shadowBlur = 5;
                    context.shadowOffsetX = 0;
                    context.shadowOffsetY = 0;            
                    }
                else
                    context.shadowColor="transparent";
                context.drawImage(imgtodown, width - startx,this.baseline+ this.height/2 -8,16,16);
                startx +=20;
        
            }
    

        }
        context.filter = "none";
        context.shadowColor="transparent";
    }


    getCursor(time)
    {
        return null; // à dériver
    }

    getMouseDown(time)
    {
        return null; // à dériver
    }

    getButton(x,y, update)
    {
        
        if (this.nobuttons) return "";

        var deca = 0;
        if (this.minimisable) deca=20;
        if ( (y >= (this.baseline+ this.height/2 -8)) && 
             (y<=this.baseline+ this.height/2 +8))
        {


            if ((x >= (this.width-20 )) && (x <= (this.width-4 ) && (this.minimisable)))
            {
                if (update) this.selectedbutton = "minagr";
                return "minagr";
            }

            if ((x >= (this.width-20 - deca)) && (x <= (this.width-4 - deca)))
            {
                if (update) this.selectedbutton = "poub";
                return "poub";
            }

            if ((!this.toptrack) && (x >= (this.width-40 - deca)) && (x <= (this.width-24 - deca)))
            {
                if (update) this.selectedbutton = "toup";
                return "toup";
            }

            if ((!this.bottomtrack) && (x >= (this.width-60 - deca)) && (x <= (this.width-44 - deca)))
            {
                if (update) this.selectedbutton = "todown";
                return "todown";
            }
                

        }
        if (update) this.selectedbutton="";
        return "";

    }

    setNewYPosition (baseline)
    {
        this.baseline = baseline;
      
    }

    setPositions(baseline, height)
    {
        this.baseline = baseline;
        this.height  = height;
    }

    getBaseLine()
    {
        return this.baseline;
    }

    

    getDefaultHeight()
    {
        return this.defaultHeight;
    }
    getHeight()
    {
        return this.height; // Retour la taille en hauteur de la piste
    }    

    isFixedHeight()
    {
        return false; // Retour vrai si la track ne peut être sizable
    }    

    getId()
    {
        return this.id;
    }


    getFile()
    {
        
        return this.file;
    }

    getType()
    {
        return this.type;
    }

    redrawForeGround (context,width)
    {

    }

    redrawbackgroundLevel1 (context, width, currentTime, sTimeCode, starttime, duration,fullheight, yStart)
    {


    }


    redrawbackgroundLevel0 (context, width)
    {

        context.fillStyle = this.backcolor;
        context.fillRect (0,this.baseline,width, this.height+1);

        context.strokeStyle ="#A0A0A0";
        context.lineWidth = 1;
        context.beginPath();
        context.moveTo(0, this.baseline + this.height);
        context.lineTo(width, this.baseline + this.height);
        context.stroke();

    }

/**
 * Dessine un rectangle à coins arrondis sur un contexte Canvas 2D.
 *
 * @param {CanvasRenderingContext2D} ctx     - contexte 2D du canvas
 * @param {number} x                         - position X (gauche) du rectangle
 * @param {number} y                         - position Y (haut) du rectangle
 * @param {number} w                         - largeur
 * @param {number} h                         - hauteur
 * @param {object} [opts]                    - options
 *    opts.radius: number | {tl,tr,br,bl}   - rayon (ou objet pour chaque coin)
 *    opts.fillStyle: string|null           - couleur de fond (null = pas de remplissage)
 *    opts.strokeStyle: string|null         - couleur de bordure (null = pas de trait)
 *    opts.lineWidth: number                - épaisseur du trait (par défaut 1)
 *    opts.strokeAlign: 'center'|'inside'|'outside' - alignement du trait (par défaut 'center')
 */
    drawRoundedRect(ctx, x, y, w, h, opts = {}) {
    if (!ctx || w <= 0 || h <= 0) return;

    const {
        radius = 0,
        fillStyle = null,
        strokeStyle = null,
        lineWidth = 1,
        strokeAlign = 'center'
    } = opts;

    // Normaliser radius en objet pour chaque coin
    const r = (typeof radius === 'number')
        ? { tl: radius, tr: radius, br: radius, bl: radius }
        : Object.assign({ tl: 0, tr: 0, br: 0, bl: 0 }, radius);

    // Calculer inset selon alignement du trait :
    // - 'center' => inset = 0 (le stroke est centré sur le contour)
    // - 'inside' => on décale le chemin vers l'intérieur de lineWidth/2
    // - 'outside' => on décale le chemin vers l'extérieur de lineWidth/2
    const half = (lineWidth || 0) / 2;
    let inset = 0;
    if (strokeStyle) {
        if (strokeAlign === 'inside') inset = half;
        else if (strokeAlign === 'outside') inset = -half;
        else inset = 0; // center
    }

    // Ajuster le rectangle selon l'inset
    const x0 = x + inset;
    const y0 = y + inset;
    const w0 = w - inset * 2;
    const h0 = h - inset * 2;
    if (w0 <= 0 || h0 <= 0) return; // plus d'espace après inset

    // Clamp des rayons pour ne pas dépasser la moitié de la largeur/hauteur
    const clamp = (v, max) => Math.max(0, Math.min(v, max));
    const tl = clamp(r.tl, Math.min(w0, h0) / 2);
    const tr = clamp(r.tr, Math.min(w0, h0) / 2);
    const br = clamp(r.br, Math.min(w0, h0) / 2);
    const bl = clamp(r.bl, Math.min(w0, h0) / 2);

    // Construire le chemin
    ctx.beginPath();
    ctx.moveTo(x0 + tl, y0);
    ctx.lineTo(x0 + w0 - tr, y0);
    if (tr > 0) ctx.quadraticCurveTo(x0 + w0, y0, x0 + w0, y0 + tr);
    else ctx.lineTo(x0 + w0, y0);

    ctx.lineTo(x0 + w0, y0 + h0 - br);
    if (br > 0) ctx.quadraticCurveTo(x0 + w0, y0 + h0, x0 + w0 - br, y0 + h0);
    else ctx.lineTo(x0 + w0, y0 + h0);

    ctx.lineTo(x0 + bl, y0 + h0);
    if (bl > 0) ctx.quadraticCurveTo(x0, y0 + h0, x0, y0 + h0 - bl);
    else ctx.lineTo(x0, y0 + h0);

    ctx.lineTo(x0, y0 + tl);
    if (tl > 0) ctx.quadraticCurveTo(x0, y0, x0 + tl, y0);
    else ctx.lineTo(x0, y0);
    ctx.closePath();

    // Remplissage puis contour (si demandés)
    if (fillStyle) {
        ctx.fillStyle = fillStyle;
        ctx.fill();
    }

    if (strokeStyle) {
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = strokeStyle;
        ctx.stroke();
    }
    }



    copyCanvasWithRoundedBorder(srcCanvas, dstCtx, dx, dy, dw, dh, options = {}) {
  const {
    radius = 20,
    borderWidth = 4,
    borderColor = "#000000"
  } = options;

  function roundedRectPath(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y,     x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x,     y + h, r);
    ctx.arcTo(x,     y + h, x,     y,     r);
    ctx.arcTo(x,     y,     x + w, y,     r);
    ctx.closePath();
  }

  const inset = borderWidth / 2;
  const innerX = dx + inset;
  const innerY = dy + inset;
  const innerW = dw - borderWidth;
  const innerH = dh - borderWidth;

  // Efface toute la zone destination avant de dessiner
  dstCtx.clearRect(dx, dy, dw, dh);

  // Clip coins arrondis
  roundedRectPath(dstCtx, innerX, innerY, innerW, innerH, radius);
  dstCtx.save();
  dstCtx.clip();

  // Dessin image forcé à innerW × innerH
  dstCtx.imageSmoothingEnabled = true;
  dstCtx.imageSmoothingQuality = "high";
  dstCtx.drawImage(
    srcCanvas,
    0, 0, srcCanvas.width, srcCanvas.height,
    innerX, innerY, innerW, innerH
  );

  dstCtx.restore();

  // Bordure
  if (borderWidth > 0) {
    dstCtx.lineWidth = borderWidth;
    dstCtx.strokeStyle = borderColor;
    roundedRectPath(dstCtx, innerX, innerY, innerW, innerH, radius);
    dstCtx.stroke();
  }
}



}



export default BaseTrack;